import React from 'react'
import AdminHospitals from '../../components/AdminHospitals/AdminHospitals'

function AdminHospitalPage() {
  return (
    <AdminHospitals />
  )
}

export default AdminHospitalPage